<template>
  <div>
    <highcharts :options="chartOptions"></highcharts>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ChartEvents } from "./chartEvents";
export default {
  name: "LineChart",

  components: {},

  props: [
    "chartSeries",
    "xAxis",
    "plotLabel",
    "ploMouse",
    "titleChart",
    "titleY",
    "idChart"
  ],

  created() {
    ChartEvents.$on(this.idChart, data => {
      this.chartOptions.series = data.newData;
      if (data.categoria != undefined) {
        this.chartOptions.xAxis = {
          categories: data.categoria
        };
      }
    });
  },

  data() {
    return {
      toggle_exclusive: undefined,
      viewReport: false,
      chartOptions: {
        chart: {
          type: "line"
        },
        credits: {
          enabled: false
        },
        title: {
          text: this.titleChart
        },
        subtitle: {
          text: ""
          // 'Click to print PDF report'
        },
        accessibility: {
          announceNewData: {
            enabled: true
          }
        },
        xAxis: {
          categories: []
        },
        yAxis: {
          title: {
            text: this.titleY
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          crosshairs: true,
          shared: true
        },
        plotOptions: {
          line: {
            marker: {
              radius: 8,
              lineColor: "#fff",
              lineWidth: 5
            },
            dataLabels: {
              enabled: this.plotLabel
            },
            enableMouseTracking: this.ploMouse
          },
          spline: {
            marker: {
              radius: 4,
              lineColor: "#666666",
              lineWidth: 1
            }
          }
        },

        // tooltip: {
        //   headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
        //   pointFormat:
        //     '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}€	</b> of total<br/>'
        // },

        series: this.chartSeries
      }
    };
  },

  computed: {
    ...mapGetters("dashboard", ["getDashboard"])
  },

  watch: {}
};
</script>
